module.exports = __webpack_public_path__ + "static/media/云台追踪.a510d320.png";